import React, {useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Modal, Menu, MenuItem } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import MovePaxModal from '../modals/MovePaxModal';
import TextPaxModal from '../modals/sms/TextPaxModal';
import TextHistoryModal from '../modals/TextHistory';
import EditPaxModal from '../modals/editPax/EditPaxModal';
import CloseFlightModal from '../modals/CloseFlightModal';
import EditDCSFlightModal from '../modals/EditDCSFlightModal'
import { loadDepartures, resetEditPaxStatus, resetTextHistory, resetMovePaxStatus, resetMovePaxList, resetMessageStatus } from '../../../store/dcs';
import { resetEditReqStatus } from '../../../store/flights';
import checkPermissions from '../../../utils/checkPermissions'
import { formatFlightDate } from '../util/formatFlightDate';


export const ActionsMenu = (props) => {
  const userType = useSelector(state => state.entities.auth.userType)
  const depDate = useSelector(state => state.entities.dcs.departureDate);
  const isMobile = props.isMobile || false
  const modalClasses = props.modalClasses
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const [openTextModal, setTextModal] = useState(false);
  const [openTextHistory, setTextHistoryModal] = useState(false);
  const [openMovePax, setMoveModal] = useState(false);
  const [openEditModal, setEditModal] = useState(false)
  const [openFlightStatus, setFlightStatusModal] = useState(false)
  const [openEditDCSFlight, setEditDCSFlightModal] = useState(false)
  const flight = props.row
  const date = props.date
  const paxInfo = flight.passengers || []
  const dispatch = useDispatch()
  const airline = useSelector(state => state.entities.dcs.airline)
  const [getmovePaxStatus,setMovePaxStatus]=useState();
  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget)
  };
  
  function handleMovePaxStatusChange(status)
  {
    setMovePaxStatus(status);
  }

  const handleCloseEditDCSFlight = () => {
    setEditDCSFlightModal(false)
    dispatch(loadDepartures(date))
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  };

  const handleCloseEditModal = () => {
    dispatch(resetEditPaxStatus())
    setEditModal(false)
  };

  const handleCloseMovePaxModal = () => {
    // NOTE // resetting the status for moving the pax
    dispatch(resetMovePaxStatus())
    // NOTE // resetting the flight choices
    dispatch(resetMovePaxList())
    // NOTE // resetting the flight choices request status
    dispatch(resetMessageStatus())
    // NOTE // closing the modal
    setMoveModal(false)
    
    //Used for Rendering the DCS
    if(getmovePaxStatus==="Success"|| getmovePaxStatus==="Failed" ||getmovePaxStatus==="Loading")
    {
    dispatch(loadDepartures(formatFlightDate(depDate)));
    }

  }

  const handleCloseHistory = () => {
    setTextHistoryModal(false)
    dispatch(resetTextHistory())
  }

  const handleCloseFlight = () => {
    setFlightStatusModal(false)
    dispatch(resetEditReqStatus())
  }

  return (
    <div>
      <IconButton
        aria-label="more" 
        aria-controls="simple-menu"
        aria-haspopup="true"
        size="small"
        onClick={handleOpenMenu}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="simple-menu"
        anchorEl={anchorEl}
        keepMounted
        open={openMenu}
        onClose={handleCloseMenu}
        PaperProps={{
          style: {
            maxHeight: '200px',
            width: '20ch',
          },
        }}
      >
        {
          paxInfo && !!paxInfo.length ? <div>
            <MenuItem disabled={!checkPermissions(userType, airline, 'movePax')} style={{ display: checkPermissions(userType, airline, 'movePax', true) }} onClick={() => {setMoveModal(true)}}>Move Pax</MenuItem>
            <MenuItem disabled={!checkPermissions(userType, airline, 'textPax')} style={{ display: checkPermissions(userType, airline, 'movePax', true) }} onClick={() => {setTextModal(true)}}>Text Pax</MenuItem>
            <MenuItem disabled={!checkPermissions(userType, airline, 'textPax')} style={{ display: checkPermissions(userType, airline, 'movePax', true) }} onClick={() => {setTextHistoryModal(true)}}>TextHistory</MenuItem>
            <MenuItem disabled={!checkPermissions(userType, airline, 'editPax')} onClick={() => {setEditModal(true)}}>Edit Pax</MenuItem>
          </div> :
          <div></div>
        }
        <MenuItem disabled={!checkPermissions(userType, airline, 'editDCSFlight')} style={{ display: checkPermissions(userType, airline, 'editDCSFlight', true) }} onClick={() => setEditDCSFlightModal(true)}>Edit Flight</MenuItem>
        <MenuItem disabled={!checkPermissions(userType, airline, 'closeFlight')} onClick={() => {setFlightStatusModal(true)}}>{flight.status === 'open' ? 'Close Flight' : 'Open Flight'}</MenuItem>
      </Menu>
      <Modal
        open={openTextModal}
        onClose={() => {setTextModal(false)}}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{overflow: 'scroll'}}
      >
        <TextPaxModal paxInfo={paxInfo} closeModal={setTextModal} modalClasses={modalClasses} />
      </Modal>
      <Modal
        open={openMovePax}
        onClose={handleCloseMovePaxModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{overflow: 'scroll'}}
      >
        <MovePaxModal flight={flight} closeModal={handleCloseMovePaxModal} changeMovePaxStatus={handleMovePaxStatusChange} modalClasses={modalClasses} isMobile={isMobile} />
      </Modal>
      <Modal
        open={openEditModal}
        onClose={handleCloseEditModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{overflow: 'scroll'}}
      >
        <EditPaxModal flight={flight} closeModal={handleCloseEditModal} modalClasses={modalClasses} isMobile={isMobile} />
      </Modal>
      <Modal
        open={openTextHistory}
        onClose={handleCloseHistory}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{overflow: 'scroll'}}
      >
        <TextHistoryModal flight={flight} date={date} closeModal={handleCloseHistory} modalClasses={modalClasses} />
      </Modal>
      <Modal
        open={openEditDCSFlight}
        onClose={handleCloseEditDCSFlight}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{overflow: 'scroll'}}
      >
        <EditDCSFlightModal flight={flight} flightDate={date} closeModal={handleCloseEditDCSFlight} modalClasses={modalClasses} isMobile={isMobile} />
      </Modal>
      <Modal
        open={openFlightStatus}
        onClose={handleCloseFlight}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{overflow: 'scroll'}}
      >
        <CloseFlightModal flight={flight} date={date} closeModal={handleCloseFlight} modalClasses={modalClasses} isMobile={isMobile} />
      </Modal>
    </div>
  )
}